// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__363e5","list":"BalanceDue_list__2hiyu","listRow":"BalanceDue_listRow__3o9qa","total":"BalanceDue_total__2jLuI"};